import React from 'react'

function PaymentSteps() {
  return (
    <div id="stepper">
      <ul class="steps">
        <li class="complete">
          <span>Payment completed</span>
        </li>
        <li class="non-active">
          <span>Autopay mode</span>
        </li>
      <li class="">
        <span>Setup Autopay</span>
      </li>
    </ul>
  </div>
  )
}

export default PaymentSteps
